import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Mask } from '@instructure/ui-overlays';
import { Tray } from '@instructure/ui-tray';
import { Portal } from '@instructure/ui-portal';
import { Dialog } from '@instructure/ui-dialog';
import { Button } from '@instructure/ui-buttons';
import { Alert } from '@instructure/ui-alerts';
import { Text } from '@instructure/ui-text';
import t from '@instructure/quiz-i18n/es/format-message';
import Banks from '../../../../banks/components/Banks';
import BankEntry from '../../../../banks/components/BankEntry';
import Bank from '../../../../banks/components/Bank';
import { liveRegion, BUILD_TRAY_OPEN, BUILD_TRAY_POSITION, BUILD_TRAY_STIMULUS_ID, TRAY_ALERT_OPEN, BANKS_BANK_PAGINATION } from '@instructure/quiz-common';
export var BanksTray = /*#__PURE__*/function (_Component) {
  function BanksTray() {
    var _this;
    _classCallCheck(this, BanksTray);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BanksTray, [].concat(args));
    _defineProperty(_this, "closeTray", function () {
      if (_this.props.trayTrigger) {
        _this.props.trayTrigger.focus();
      }
      _this.props.setUI(BUILD_TRAY_OPEN, false);
      _this.props.setUI(BUILD_TRAY_POSITION, null);
      _this.props.setUI(BUILD_TRAY_STIMULUS_ID, null);
    });
    _defineProperty(_this, "clearActiveBank", function () {
      _this.props.newActiveBank(void 0);
      _this.props.newActiveBankEntry(void 0);
    });
    _defineProperty(_this, "navigateToBank", function (bankId) {
      _this.props.newActiveBankEntry(void 0);
      _this.props.newActiveBank(bankId);
    });
    _defineProperty(_this, "handleCloseAlert", function () {
      _this.props.setUI(TRAY_ALERT_OPEN, false);
      _this.clearActiveBank();
      _this.props.clear(BANKS_BANK_PAGINATION);
    });
    return _this;
  }
  _inherits(BanksTray, _Component);
  return _createClass(BanksTray, [{
    key: "renderTrayContent",
    value: function renderTrayContent() {
      var _this$props = this.props,
        activeBankEntryId = _this$props.activeBankEntryId,
        activeBankId = _this$props.activeBankId;
      if (activeBankId) {
        if (activeBankEntryId) {
          return /*#__PURE__*/React.createElement(BankEntry, {
            isCompact: true,
            closeTray: this.closeTray,
            bankId: activeBankId,
            bankEntryId: activeBankEntryId,
            navigateToBanks: this.clearActiveBank,
            navigateToBank: this.navigateToBank,
            scope: this.props.itemBanksScope
          });
        } else {
          return /*#__PURE__*/React.createElement(Bank, {
            isCompact: true,
            closeTray: this.closeTray,
            bankId: activeBankId,
            navigateToBanks: this.clearActiveBank,
            navigateToBankEntry: this.props.newActiveBankEntry,
            scope: this.props.itemBanksScope
          });
        }
      } else {
        return /*#__PURE__*/React.createElement(Banks, {
          isCompact: true,
          closeTray: this.closeTray,
          currentUser: this.props.currentUser,
          navigateToBank: this.props.newActiveBank,
          getCourseInfo: this.props.getCourseInfo,
          getCourseAssignments: this.props.getCourseAssignments,
          getUserInfo: this.props.getUserInfo,
          getSubaccountInfo: this.props.getSubaccountInfo,
          getShareableCourses: this.props.getShareableCourses,
          getShareableUsers: this.props.getShareableUsers,
          getShareableSubaccounts: this.props.getShareableSubaccounts,
          minChars: this.props.minChars,
          onShare: this.props.onShare,
          scope: this.props.itemBanksScope
        });
      }
    }
  }, {
    key: "renderTrayAlert",
    value: function renderTrayAlert() {
      var alertTitle = t('Resource no longer available.');
      var alertBody = t('This item or your permissions to it may have been removed by another user.');
      return /*#__PURE__*/React.createElement(Portal, {
        open: this.props.trayAlertOpen
      }, /*#__PURE__*/React.createElement(Mask, {
        fullscreen: true,
        placement: "top"
      }, /*#__PURE__*/React.createElement(Dialog, {
        open: this.props.trayAlertOpen,
        shouldReturnFocus: true,
        shouldContainFocus: true,
        onDismiss: this.handleCloseAlert,
        label: "".concat(alertTitle, " ").concat(alertBody)
      }, /*#__PURE__*/React.createElement(Alert, {
        variant: "error",
        margin: "small 0"
      }, /*#__PURE__*/React.createElement(Text, {
        weight: "bold"
      }, alertTitle), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Text, {
        color: "primary"
      }, alertBody), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
        margin: "small 0 0 0",
        color: "primary",
        size: "small",
        onClick: this.handleCloseAlert
      }, t('Ok'))))));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tray, {
        label: t('Browse item banks'),
        liveRegion: liveRegion,
        open: this.props.trayOpen,
        placement: "end",
        size: "medium",
        shouldContainFocus: true,
        "data-automation": "sdk-banks-tray"
      }, this.renderTrayContent()), this.renderTrayAlert());
    }
  }]);
}(Component);
_defineProperty(BanksTray, "propTypes", {
  activeBankId: PropTypes.string,
  activeBankEntryId: PropTypes.string,
  clear: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    bank_admin: PropTypes.bool,
    can_share_banks_with_subaccounts: PropTypes.bool,
    email: PropTypes.string,
    enrollment_names: PropTypes.arrayOf(PropTypes.string),
    full_name: PropTypes.string,
    uuid: PropTypes.string,
    account_name: PropTypes.string
  }),
  getCourseInfo: PropTypes.func,
  getCourseAssignments: PropTypes.func,
  getUserInfo: PropTypes.func,
  getShareableCourses: PropTypes.func,
  getShareableUsers: PropTypes.func,
  getShareableSubaccounts: PropTypes.func,
  getSubaccountInfo: PropTypes.func,
  minChars: PropTypes.number,
  newActiveBank: PropTypes.func.isRequired,
  newActiveBankEntry: PropTypes.func.isRequired,
  onShare: PropTypes.func,
  setUI: PropTypes.func.isRequired,
  trayAlertOpen: PropTypes.bool.isRequired,
  trayOpen: PropTypes.bool.isRequired,
  trayTrigger: PropTypes.shape({
    focus: PropTypes.func
  }),
  itemBanksScope: PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    title: PropTypes.string,
    launch_context_uuid: PropTypes.string,
    root_account_name: PropTypes.string
  })
});
_defineProperty(BanksTray, "defaultProps", {
  activeBankId: null,
  activeBankEntryId: null,
  currentUser: null,
  getShareableCourses: null,
  getShareableUsers: null,
  getShareableSubaccounts: null,
  getSubaccountInfo: null,
  minChars: void 0,
  getCourseInfo: null,
  getCourseAssignments: null,
  getUserInfo: null,
  onShare: function onShare() {},
  trayTrigger: null,
  itemBanksScope: {}
});
export default BanksTray;